module.exports = __webpack_public_path__ + "img/fangwei.a93d238b.png";